import { ref } from 'vue'
import { useToast } from 'primevue/usetoast'

export const useAuthErrors = () => {
    const toast = useToast()

    const handleAuthError = (error: any, operation: string) => {
        console.error(`${operation} failed:`, error)

        let message = 'Произошла неизвестная ошибка'

        if (error?.response?.status) {
            switch (error.response.status) {
                case 400:
                    message = 'Неверные данные запроса'
                    break
                case 401:
                    message = 'Неверные учетные данные'
                    break
                case 403:
                    message = 'Доступ запрещен'
                    break
                case 404:
                    message = 'Ресурс не найден'
                    break
                case 422:
                    message = 'Ошибка валидации данных'
                    break
                case 429:
                    message = 'Слишком много запросов. Попробуйте позже'
                    break
                case 500:
                    message = 'Внутренняя ошибка сервера'
                    break
                default:
                    message = `Ошибка ${error.response.status}`
            }
        } else if (error?.message) {
            message = error.message
        }

        toast.add({
            severity: 'error',
            summary: 'Ошибка аутентификации',
            detail: message,
            life: 5000,
        })

        return message
    }

    const showSuccessToast = (message: string, summary = 'Успешно') => {
        toast.add({
            severity: 'success',
            summary,
            detail: message,
            life: 3000,
        })
    }

    const showInfoToast = (message: string, summary = 'Информация') => {
        toast.add({
            severity: 'info',
            summary,
            detail: message,
            life: 4000,
        })
    }

    const showWarningToast = (message: string, summary = 'Предупреждение') => {
        toast.add({
            severity: 'warn',
            summary,
            detail: message,
            life: 4000,
        })
    }

    return {
        handleAuthError,
        showSuccessToast,
        showInfoToast,
        showWarningToast
    }
}
